import React from 'react';
import usePriceSection from '../../hooks/usePriceSection';
import { CusProductListPriceSectionProps } from '../../cus-product-list.data';

export default function PriceSection({
    minPrice,
    maxPrice,
    currency,
    priceFilterHeading,
    minimumPriceAriaLabel,
    maximumPriceAriaLabel,
    selectedRange,
    onChange
}: CusProductListPriceSectionProps) {
    const {
        minVal,
        maxVal,
        minPercent,
        maxPercent,
        isCollapsed,
        trackRef,
        toggleCollapsed,
        startDrag,
        handleDragMove,
        handleDragEnd
    } = usePriceSection({
        minPrice,
        maxPrice,
        selectedRange,
        onChange
    });

    if (minPrice === maxPrice) {
        return null;
    }

    return (
        <section className='bs-product-list-filters__section'>
            <button
                type='button'
                className='bs-product-list-filters__section__title'
                onClick={toggleCollapsed}
                aria-expanded={!isCollapsed}
            >
                {priceFilterHeading}
                <span className='bs-product-list-filters__section__title__chevron' aria-hidden='true' />
            </button>
            <div className={`bs-price-range-slider${isCollapsed ? ' --collapsed' : ''}`}>
                <div className='bs-price-range-slider__values'>
                    <span className={minVal !== minPrice ? 'bs-price-range-slider__values--active' : ''}>
                        {minVal} {currency}
                    </span>
                    <span className={maxVal !== maxPrice ? 'bs-price-range-slider__values--active' : ''}>
                        {maxVal} {currency}
                    </span>
                </div>
                <div className='bs-price-range-slider__track' ref={trackRef}>
                    <div
                        className='bs-price-range-slider__track__fill'
                        style={{ left: `${minPercent}%`, width: `${maxPercent - minPercent}%` }}
                    />
                    <div
                        className='bs-price-range-slider__handle'
                        role='slider'
                        aria-label={minimumPriceAriaLabel}
                        aria-valuemin={minPrice}
                        aria-valuemax={maxVal - 1}
                        aria-valuenow={minVal}
                        tabIndex={0}
                        style={{ left: `${minPercent}%`, touchAction: 'none' }}
                        onPointerDown={startDrag('min')}
                        onPointerMove={handleDragMove}
                        onPointerUp={handleDragEnd}
                        onPointerCancel={handleDragEnd}
                    />
                    <div
                        className='bs-price-range-slider__handle'
                        role='slider'
                        aria-label={maximumPriceAriaLabel}
                        aria-valuemin={minVal + 1}
                        aria-valuemax={maxPrice}
                        aria-valuenow={maxVal}
                        tabIndex={0}
                        style={{ left: `${maxPercent}%`, touchAction: 'none' }}
                        onPointerDown={startDrag('max')}
                        onPointerMove={handleDragMove}
                        onPointerUp={handleDragEnd}
                        onPointerCancel={handleDragEnd}
                    />
                </div>
            </div>
        </section>
    );
}
